import axios from 'axios'
import { getRestApiConfig } from '../config'
import { AxiosErrorResult } from '../errors'
import type { DynamicRequestBody, DynamicSiteResponse } from './types'

export const postDynamicData = async (
    props: DynamicRequestBody,
): Promise<DynamicSiteResponse> => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(
            `/api/v1/DynamicSites`,
            restApiConfig.baseUrl,
        ).href
        const response = await axios.post<DynamicSiteResponse>(
            endpointUrl,
            props,
            { headers: { ...restApiConfig.authHeader } },
        )
        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const getDynamicVideo = async (videoName?: string): Promise<string> => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(
            `/api/v1/videos?videoName=${videoName}`,
            restApiConfig.baseUrl,
        ).href
        const response = await axios.get<string>(endpointUrl, {
            headers: {
                ...restApiConfig.authHeader,
                accept: 'video/mp4;charset=utf-8',
            },
        })

        return response.data
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}

export const getDynamicImage = async (
    image?: string | null,
): Promise<string> => {
    try {
        const restApiConfig = getRestApiConfig()
        const endpointUrl = new URL(
            `/api/v1/Images/Base64?imageName=${image}`,
            restApiConfig.baseUrl,
        ).href
        const response = await axios.get<string>(endpointUrl, {
            headers: {
                ...restApiConfig.authHeader,
            },
        })

        return `data:${response.headers['content-type']};base64,${response.data}`
    } catch (e: any) {
        throw AxiosErrorResult(e)
    }
}
